(function () {
  'use strict';

  /* @ngdoc object
   * @name main.logos
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.logos', [
      'ui.router'
    ]);
}());
